import { ApolloError, useQuery } from '@apollo/client'
import { COMPANIES_AND_COUNTRIES_OF_COMPANY_MANAGER } from '../Queries'
import { FindCompaniesAndCountriesByCompanyManagerQuery, FindCompaniesAndCountriesByCompanyManagerQueryVariables } from '../../../types'

// When this method is called in the Cultivating Talents view, you must specify the parameter to true.
// If the user accessing the view is a business partner of his current company-country,
// this company-country pair must be excluded from the query result,
// otherwise the business partner would see the tags and rank that a company manager assigned to him.
export const useCompaniesAndCountriesOfCompanyManager = (
  excludeBusinessPartnerCompanies?: boolean,
): { data: FindCompaniesAndCountriesByCompanyManagerQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<
    FindCompaniesAndCountriesByCompanyManagerQuery,
    FindCompaniesAndCountriesByCompanyManagerQueryVariables
  >(COMPANIES_AND_COUNTRIES_OF_COMPANY_MANAGER, { variables: { excludeBusinessPartnerCompanies } })

  return { data, error, loading }
}
